import { STATE_STATUS } from '@mgCommon/constants/constants.js';
import { convertDateToEpoch, encodeUrl, generateUUID } from '@mgCommon/utils/utils.js';
import InterstitialService from '@mgServices/interstitial.service.js';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTemplate: {},
  status: STATE_STATUS.IDLE,
  error: null,
};

export const sendProofingInterstitial = createAsyncThunk(
  'interstitial/sendProofingInterstitial',
  async ({ recipients = [] }, { getState }) => {
    const { selectedTemplate } = getState().interstitial;
    const formData = getState().interstitialFormData;
    let { templateGr, templateEn } = formData;

    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1);
    const epochExpirationDate = convertDateToEpoch({ date: expirationDate });

    selectedTemplate?.dynamicVariables?.forEach(d => {
      const replace = `[[${d.name}]]`;
      templateGr = templateGr.replaceAll(replace, d.proofingValue);
      templateEn = templateEn.replaceAll(replace, d.proofingValue);
    });

    const campaignId = generateUUID();
    const inArguments = {
      interstitialId: '',
      playerId: '',
      campaignId,
      titleGr: formData.titleGr,
      titleEn: formData.titleEn,
      templateGr,
      templateEn,
      backgroundImage: formData.backgroundImage,
      name: formData.name,
      position: formData.position,
      backgroundColor: formData.backgroundColor,
      defaultColor: formData.defaultColor,
      size: formData.size,
      closeButton: formData.closeButton,
      expirationTimer: Number(formData.expirationTimer),
      priority: Number(formData.priority),
      animation: formData.animation || null,
      animationSpawn: formData.animationSpawn || null,
      game: formData.game,
      expirationDate: epochExpirationDate,
      interstitialType: formData.interstitialType,
      hasHyperLink: formData.hasHyperLink,
      interstitialsMode: formData.interstitialsMode,
      closeButtonColor: formData.closeButtonColor,
      eligibleUrl: encodeUrl(formData.eligibleUrl),
    };
    const res = await InterstitialService.sendInterstitial({ recipients, inArguments });
    return res.data;
  }
);

const interstitialSlice = createSlice({
  name: 'interstitial',
  initialState,
  reducers: {
    setInterstitialSelectedTemplate(state, { payload }) {
      state.selectedTemplate = payload.template;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(sendProofingInterstitial.pending, state => {
        state.status = STATE_STATUS.LOADING;
      })
      .addCase(sendProofingInterstitial.fulfilled, state => {
        state.status = STATE_STATUS.SUCCEEDED;
      })
      .addCase(sendProofingInterstitial.rejected, (state, { error }) => {
        state.status = STATE_STATUS.FAILED;
        state.error = error.message;
      });
  },
});

export const { setInterstitialSelectedTemplate } = interstitialSlice.actions;

export default interstitialSlice.reducer;
